/**
 * <p>****************************************************************************</p>
 * <p><b>Copyright © 2010-2019 soho team All Rights Reserved<b></p>
 * <ul style="margin:15px;">
 * <li>Description : </li>
 * <li>Version     : 1.0</li>
 * <li>Creation    : 2019年08月25日</li>
 * <li>@author     : ____′↘夏悸</li>
 * </ul>
 * <p>****************************************************************************</p>
 */
import Ajax from '../js/common/ajax';

export default {
	loadSubject(params = {}) {
		return Ajax.get("/accountbook/list", params)
	},
	loadVoucherDetails(params = {}) {
		return Ajax.get("/accountbook/details", params)
	},
	loadGeneralLedger(params = {}) {
		return Ajax.get("/accountbook/generalLedger", params)
	},
	loadSubjectBalance(params = {}) {
		return Ajax.get("/accountbook/subjectBalance", params)
	},
	loadSubjectSummary(params = {}) {
		return Ajax.get("/accountbook/subjectSummary", params)
	},
	loadAuxiliaryDetails(params = {}) {
		return Ajax.get("/accountbook/auxiliaryDetails", params)
	},
	loadAuxiliaryList(params = {}) {
		return Ajax.get("/accountbook/auxiliaryList", params)
	},
	loadAuxiliaryBalance(params = {}) {
		return Ajax.get("/accountbook/auxiliaryBalance", params)
	},
	loadChronologicalLedger(params = {}) {
		return Ajax.get("/accountbook/chronologicalLedger", params)
	},
	loadChronologicalLedgerWithFilter(params = {}) {
		return Ajax.get("/accountbook/chronologicalLedgerWithFilter", params)
	},
	loadVoucherDetailsByOppositeSubject(params = {}) {
		return Ajax.get("/accountbook/detailsByOppositeSubject", params)
	}
}